export default "__VITE_ASSET__827580ec__"